import { useMemo } from 'react';

export function useTimezoneOptions(currentValue: string) {
  return useMemo(() => {
    const timezones =
      typeof Intl.supportedValuesOf === 'function'
        ? Intl.supportedValuesOf('timeZone')
        : ['UTC'];
    const values = timezones.includes(currentValue)
      ? timezones
      : [currentValue, ...timezones];
    return values.map((timezone) => ({
      label: timezone,
      value: timezone,
    }));
  }, [currentValue]);
}
